import { createContext, useContext } from "react";

// Set for screens rendered inside a wide-layout group (components/layout/AdaptiveGroup.js);
// null on phones and for full-screen routes. Value:
// - kind: "pane" (right side of the event's split view), "full" (the whole event
//   frame, e.g. checkout) or "sheet" (a screen like Profile shown in the modal frame)
// - mode: "split" | "modal"
// - width, height: the space the screen has
// - showBack: whether the screen's own back/cancel button is needed. A pane opened
//   from the event menu has none, the menu is right next to it.
export const FrameContext = createContext(null);

export const useFrame = () => useContext(FrameContext);
